// material
import { Box, Grid, Container, Typography } from "@mui/material";
// components
import Page from "../components/Page";
import {
  AppTasks,
  AppNewUsers,
  AppBugReports,
  AppItemOrders,
  AppNewsUpdate,
  AppWeeklySales,
  AppOrderTimeline,
  AppCurrentVisits,
  AppWebsiteVisits,
  AppTrafficBySite,
  AppCurrentSubject,
  AppConversionRates,
  AppIngresoPorDelegado,
} from "../sections/@dashboard/app";

// ----------------------------------------------------------------------
//import useAuth from "../hooks/useAuth";
export default function DashboardApp() {
  //const { auth } = useAuth();
  return (
    <Page title="Dashboard | Minimal-UI">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          {/* <Typography variant="h4">Hola, {auth.usuario}</Typography> */}
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={8}>
            <AppWebsiteVisits />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <AppCurrentVisits />
          </Grid>

          <Grid item xs={12} md={6} lg={12}>
            <AppConversionRates />
          </Grid>
          <Grid item xs={12} md={6} lg={12}>
            <AppIngresoPorDelegado />
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
